/** Геометрия сцены (ТЗ §6.1). Вертикальный формат TikTok, деление горизонтальное. */

import type { TeamId } from './config.js';

export const SCENE_W = 1080;
export const SCENE_H = 1920;

/** Верхняя панель: полосы тронов, счёт живых, очередь. */
export const HUD_H = 168;
/** Подвал: оверлей цен, лайки, лента событий. */
export const FOOTER_H = 250;

export const ARENA_TOP = HUD_H;
export const ARENA_BOTTOM = SCENE_H - FOOTER_H;
export const ARENA_H = ARENA_BOTTOM - ARENA_TOP;

/** Троны стоят по центру по горизонтали: армии идут навстречу друг другу. */
export const THRONE_X = SCENE_W / 2;

/** Y центра трона. Команда A сверху, B снизу. */
export function throneY(team: TeamId, offset: number): number {
  return team === 'A' ? ARENA_TOP + offset : ARENA_BOTTOM - offset;
}

/** Направление марша команды: A идёт вниз, B — вверх. */
export function marchDir(team: TeamId): 1 | -1 {
  return team === 'A' ? 1 : -1;
}

/** Колонна очереди стоит у самого края за своим троном. */
export const QUEUE_GAP = 40;
export const QUEUE_EDGE = 26;

/**
 * Место бойца в колонне очереди. Считается и рендером, и симуляцией: оружие
 * донатера, который ещё не попал в бой, вылетает именно из его аватарки
 * в очереди, а не из трона.
 */
export function queueSlotPos(
  team: TeamId,
  index: number,
  visibleSlots: number,
): { x: number; y: number } {
  const i = Math.max(0, Math.min(index, visibleSlots - 1));
  const startX = SCENE_W / 2 - ((visibleSlots - 1) * QUEUE_GAP) / 2;
  return {
    x: startX + i * QUEUE_GAP,
    y: team === 'A' ? ARENA_TOP + QUEUE_EDGE : ARENA_BOTTOM - QUEUE_EDGE,
  };
}
